import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Layout } from '../components/Layout';
import { DataTable } from '../components/DataTable';
import { useAuth } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL || 'https://tecteach-server.vercel.app/api/v1';

interface UsersProps {
  course?: 'uaup' | 'intro-to-ai' | 'genai' | 'all';
  title?: string;
}

const Users: React.FC<UsersProps> = ({ course, title }) => {
  const { admin } = useAuth();
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Detect course from route if not provided as prop
  const getCourseFromRoute = () => {
    if (course) return course;
    if (location.pathname.includes('/uaup/')) return 'uaup';
    if (location.pathname.includes('/intro-to-ai/')) return 'intro-to-ai';
    if (location.pathname.includes('/genai/')) return 'genai';
    return 'all';
  };

  const detectedCourse = getCourseFromRoute();

  const getPageTitle = () => {
    if (title) return title;
    switch (detectedCourse) {
      case 'uaup':
        return 'UAUP Users';
      case 'intro-to-ai':
        return 'Intro to AI Users';
      case 'genai':
        return 'GenAI Users';
      default:
        return 'All Users';
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        let url = `${API_URL}/users?whiteLabelClientId=${admin?.whiteLabelClientId}`;
        if (detectedCourse !== 'all') {
          url += `&course=${detectedCourse}`;
        }
        const response = await axios.get(url);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    if (admin?.whiteLabelClientId) {
      fetchUsers();
    }
  }, [admin, detectedCourse]);

  const columns = [
    { id: 'name', label: 'Name' },
    { id: 'email', label: 'Email' },
    {
      id: 'createdAt',
      label: 'Joined Date',
      format: (value: string) => format(new Date(value), 'MMM dd, yyyy'),
    },
  ];

  return (
    <Layout>
      <Box>
        <Typography variant="h4" fontWeight={700} color="#142060" gutterBottom>
          {getPageTitle()}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Manage {detectedCourse === 'all' ? 'all' : detectedCourse.toUpperCase()} users in your platform
        </Typography>

        <DataTable columns={columns} data={users} loading={loading} />
      </Box>
    </Layout>
  );
};

export default Users;
